// src/utils/axios.js
import axios from 'axios';
import Cokie from 'js-cookie';
import {BASE_API, CONFIG} from '../config';
import {generateSignature} from '../apiSign';

console.log('API Base URL:', BASE_API); // 调试信息

// 创建axios实例
const http = axios.create({
    baseURL: BASE_API, // 从配置文件获取 API 的基础路径
    timeout: CONFIG.timeout, // 请求超时时间
    withCredentials: true, // 允许跨域请求携带凭证
});

// 添加请求拦截器
http.interceptors.request.use(
    async (config) => {
        // 调试信息
        console.log('Request URL:', `${config.baseURL}${config.url}`);

        // 生成签名信息
        const signatureInfo = await generateSignature();

        // 将签名信息添加到请求头
        config.headers['X-S-Str1'] = signatureInfo.str1;
        config.headers['X-S-Str2'] = signatureInfo.str2;
        config.headers['X-S-Str3'] = signatureInfo.str3;
        config.headers['X-S'] = signatureInfo.sign;
        config.headers['Timestamp'] = signatureInfo.tmp;

        const token = Cokie.get('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        console.error('Request Error:', error);
        return Promise.reject(error);
    }
);

// 添加响应拦截器
http.interceptors.response.use(
    response => {
        // 调试信息
        console.log('Response:', response.config.url, response.data);
        return response.data;
    },
    error => {
        // 详细的错误处理
        if (error.response) {
            // 服务器返回了错误状态码
            console.error('Response Error:', error.response.status, error.response.data);

            switch (error.response.status) {
                case 401:
                    console.error('Unauthorized, please login again.');
                    break;
                case 404:
                    console.error('API not found:', error.config.url);
                    break;
                case 500:
                    console.error('Server error');
                    break;
                default:
                    console.error(`Error with status code: ${error.response.status}`);
            }
        } else if (error.request) {
            // 请求发送了但没有收到响应
            console.error('No response received:', error.request);
        } else {
            // 请求配置出错
            console.error('Request config error:', error.message);
        }

        return Promise.reject(error);
    }
);

export default http;
